// extracted by mini-css-extract-plugin
module.exports = {"Summary":"Summary_Summary__wfLqe","Image":"Summary_Image__OAsXp","Details":"Summary_Details__esDFS","Header":"Summary_Header__z6Z6G"};